'use strict'; /* eslint-disable no-console, no-unused-vars */

/**
 * scrollNav updates the active section name
 * in a (sticky) nav based on which section
 * on the page the user is scrolling through
 */

import _ from 'lodash';
import scrollClassToggle from './scroll-class-toggle';

const scrollNav = (function() {

	// borrowed functions from scrollClassToggle
	const getElementBottom = scrollClassToggle.getElementBottom;
	const addClass = scrollClassToggle.addClass;
	const removeClass = scrollClassToggle.removeClass;

	const activeClass = 'js-is-active';
	let scrollTop, firstContentSection, navAnchors, targetId, sectionSelector, sectionTop, sectionBottom;

	/**
	 * getElementTop
	 *
	 * Get target element offset from screenTop
	 *
	 * @param target: target HTML element
	 *
	 * @returns number
	 */
	function getElementTop(target) {
		const rect = target.getBoundingClientRect();

		return rect.top + window.pageYOffset - 150;
	}

	/**
	 * hasClass
	 *
	 * Check if an element has a specific classname
	 *
	 * @param element: target HTML element
	 * @param className: classname to check for
	 */
	function hasClass(element, className) {
		return element.classList ? element.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(element.className);
	}

	/**
	 * updateActiveLink
	 *
	 * Called in scrollHandler, adds an active class
	 * to a nav link when scrolling through a
	 * section with the target id
	 *
	 * @param navAnchor: nav links
	 * @param positionValues: object from getSectionPosition that includes
	 *    targetId: nav link id target
	 *    sectionSelector: section targeted by id
	 *    sectionTop: section's top position
	 *    sectionBottom: section's bottom position
	 */
	function updateActiveLink(navAnchor, positionValues) {
		const navLink = navAnchor.parentNode;
		const prevLink = navLink.previousElementSibling;
		const nextNavLink = navLink.nextElementSibling;

		sectionTop = positionValues.sectionTop;
		sectionBottom = positionValues.sectionBottom;

		if (scrollTop > sectionTop) {
			addClass(navLink, activeClass);
			const navLabel = document.querySelector('.title-nav__mobile .label');
			if (navLabel) {
				navLabel.textContent = navLink.textContent;
			}
			if (prevLink !== null && hasClass(prevLink, activeClass)) {
				removeClass(prevLink, activeClass);
			}
			if (nextNavLink !== null && hasClass(nextNavLink, activeClass)) {
				removeClass(nextNavLink, activeClass);
			}
		} else {
			removeClass(navLink, activeClass);
		}

		const activeLink = document.querySelector(`.title-nav .${activeClass}`);
		// there is nothing active, so mark the first element as active
		if (!activeLink) {
			addClass(document.querySelector('.title-nav li'), activeClass);
		}
	}

	/**
	 * getSectionPosition
	 *
	 * Grabs position values for targeted section tops
	 * & bottoms using nav link reference
	 *
	 * @param navAnchor: nav links
	 *
	 * @returns Object|null
	 */
	function getSectionPosition(navAnchor) {
		targetId = navAnchor.getAttribute('href');
		sectionSelector = document.querySelector(targetId);

		if (!sectionSelector) {
			return null;
		}

		sectionTop = getElementTop(sectionSelector);
		sectionBottom = getElementBottom(sectionSelector);

		return {
			targetId,
			sectionSelector,
			sectionTop,
			sectionBottom,
		};
	}

	/**
	 * scrollHandler
	 *
	 * Grabs iterated nav links, section positions,
	 * and passes their selectors & values
	 * to updateActiveLink
	 */
	function scrollHandler() {

		[].forEach.call(navAnchors, (navAnchor) => {
			const positionValues = getSectionPosition(navAnchor);

			if (positionValues) {
				updateActiveLink(navAnchor, positionValues);
			}
		});
	}

	/**
	 * Scroll the target element into view
	 *
	 * @param {Event} e
	 *
	 * @returns bool|void
	 */
	function scrollToElement(e) {
		if (typeof document.body.scrollIntoView !== 'function') {
			return;
		}

		e.preventDefault();
		
		const id = this.getAttribute('href').slice(1);
		
		const element = document.getElementById(id);

		if (element) {
			element.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
				inline: 'start',
			});
		}

		return false;
	}

	/**
	 * init
	 *
	 * Listens for scroll events and calls the handler
	 */
	function init() {
		const isTitlePage = hasClass(document.body, 'title-page');

		if (isTitlePage) {
			navAnchors = document.querySelectorAll('.title-nav__link a');
			if (!navAnchors) {
				console.error('No navAnchors found');
				return;
			}

			firstContentSection = (document.getElementById('overview') || document.body).getBoundingClientRect().top;
			window.addEventListener('scroll', _.throttle(() => {
				scrollTop = window.pageYOffset;

				if (scrollTop > firstContentSection) scrollHandler();
			}, 100));

			Array.prototype.slice.call(navAnchors, 0).forEach((element) => {
				element.addEventListener('click', scrollToElement);
			});
		}
	}

	window.addEventListener('DOMContentLoaded', init);

})();

export default scrollNav;



// WEBPACK FOOTER //
// ./resources/assets/js/scroll-nav.js